"use client";

import { useEffect, useRef } from "react";

/**
 * 전역 Error Boundary — 에러 발생 시 자동 복구 후 제어시스템 화면으로 복귀.
 * - 1~2차: reset() 으로 React 상태 복구 시도 (2초 후 자동)
 * - 3차 이상: /control 로 강제 이동 (sessionStorage 카운터 초기화)
 */

const RETRY_KEY = "global_error_retry";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    // sessionStorage에서 재시도 횟수 읽기
    const retryCount = parseInt(sessionStorage.getItem(RETRY_KEY) ?? "0", 10);

    if (retryCount < 3) {
      // 1~2차 시도: 2초 후 reset() 으로 React 상태 복구
      sessionStorage.setItem(RETRY_KEY, String(retryCount + 1));
      timerRef.current = setTimeout(() => {
        reset();
      }, 2000);
    } else {
      // 3차 이상: 복구 실패 → 카운터 초기화 후 제어시스템 화면으로 이동
      sessionStorage.removeItem(RETRY_KEY);
      timerRef.current = setTimeout(() => {
        window.location.href = "/control";
      }, 1000);
    }

    return () => clearTimeout(timerRef.current);
  }, [reset]);

  return (
    <div className="flex items-center justify-center min-h-[100dvh] bg-[#020617]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500 mx-auto mb-4" />
        <p className="text-slate-500 font-mono text-xs uppercase tracking-widest">
          자동 복구 중...
        </p>
      </div>
    </div>
  );
}
